import React from "react";
import { useNavigate } from "react-router-dom";

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <img 
            src="/logo.png" 
            alt="Kalobrate" 
            className="h-14 mx-auto mb-10"
          />
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-wide mb-4" style={{color: '#333333', fontFamily: 'Montech, sans-serif', textTransform: 'uppercase', letterSpacing: '0.05em'}} data-testid="landing-title">
            MAKING WORKPLACE CULTURE COUNT
          </h1>
          <p className="text-lg max-w-xl mx-auto" style={{color: '#A6A29D'}}>
            Choose the diagnostic that matches your current priority.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <button
            onClick={() => navigate('/culture')}
            data-testid="culture-card"
            className="bg-white rounded-2xl p-10 text-center border-2 border-gray-100 hover:border-yellow-300 transition-all duration-200 hover:shadow-xl group"
          >
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
              <img src="/icon-culture.png" alt="" className="w-14 h-14" />
            </div>
            <h2 className="text-xl font-semibold mb-3" style={{color: '#333333', fontFamily: 'Montech, sans-serif', textTransform: 'uppercase', letterSpacing: '0.05em'}}>
              WORKPLACE CULTURE COSTS
            </h2>
            <p className="mb-6" style={{color: '#A6A29D'}}>
              Calculate the hidden cost of turnover, absence and low morale.
            </p>
            <span className="inline-block text-white px-8 py-3 rounded-lg font-semibold transition-colors" style={{backgroundColor: '#333333'}}>
              Start Assessment
            </span>
          </button>

          <button
            onClick={() => navigate('/productivity')}
            data-testid="productivity-card"
            className="bg-white rounded-2xl p-10 text-center border-2 border-gray-100 hover:border-yellow-300 transition-all duration-200 hover:shadow-xl group"
          >
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
              <img src="/icon-productivity.png" alt="" className="w-14 h-14" />
            </div>
            <h2 className="text-xl font-semibold mb-3" style={{color: '#333333', fontFamily: 'Montech, sans-serif', textTransform: 'uppercase', letterSpacing: '0.05em'}}>
              PEOPLE PRODUCTIVITY COSTS
            </h2>
            <p className="mb-6" style={{color: '#A6A29D'}}>
              Identify hidden risks to output and quantify the productivity drag.
            </p>
            <span className="inline-block text-white px-8 py-3 rounded-lg font-semibold transition-colors" style={{backgroundColor: '#333333'}}>
              Start Diagnostic
            </span>
          </button>
        </div>

        <div className="text-center mt-10">
          <p className="text-sm" style={{color: '#A6A29D'}}>
            Based on UK industry averages &bull; Takes 3-4 minutes &bull;{' '}
            <a href="https://kalobrate.com/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:opacity-70" style={{color: '#A6A29D'}}>
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
